module.exports = __webpack_public_path__ + "static/media/11-6.99e9754c.mp3";